import { reactive } from 'vue';

export const criarUsuarioPerfil = () => {
    return reactive({
        id: 0,
        idep: 0,
        cdperfil: 0,
        nmperfil: '',
        cdescopo: 3,
        informacoes: '',
        ativo: 'S',
        ckpadrao_estab: 'N',
        ckpadrao_rt: 'N',
        idlogin: 0
    });
};